import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Yuno payment handler.
 * Handle Addi and other Yuno-provided payment methods by dispatching the
 * Yuno payment action with session data from the purchase state.
 */
const yunoPaymentHandler = {
  canHandle: ({ selectedPaymentMethod }) => selectedPaymentMethod?.provider === 'yuno',

  execute: async ({ purchase, onYunoPaymentAttempt }) => {
    const { selectedPaymentMethod, token: purchaseToken, yuno } = purchase;
    const { checkoutSession, merchantOrderId } = yuno || {};
    if (!checkoutSession || !merchantOrderId) {
      throw new Error('Missing Yuno session data for BNPL payment attempt');
    }
    await onYunoPaymentAttempt({
      checkoutSession,
      merchantOrderId,
      selectedPaymentMethod,
      purchaseToken,
    });
  },
};

registerHandler('bnpl', yunoPaymentHandler);
